import { defineComponent as _defineComponent } from 'vue';
import { trans } from 'laravel-vue-i18n';
import { DateTime } from 'luxon';
import Sidebar from 'primevue/sidebar';
import { defineAsyncComponent, ref } from 'vue';
import { useMitt } from '../Plugins/mitt';
import { useSpinner } from '../Plugins/spinner';
import LeavesDataService from '../Services/LeavesDataService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DetailsPanels',
    setup(__props, { expose }) {
        expose();
        const title = ref('');
        let component = undefined;
        const componentData = ref({});
        const sidebarVisible = ref(false);
        const emitter = useMitt();
        const leavesDataService = new LeavesDataService();
        const spinner = useSpinner();
        const FertilizationDetails = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Fertilizations/Details.vue'));
        const IrrigationDetails = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Irrigations/Details.vue'));
        const IrrigationWaterDataDetails = defineAsyncComponent(() => import('@/Pages/Orchard/IrrigationWaterData/Details.vue'));
        const SoilDataDetails = defineAsyncComponent(() => import('@/Pages/Orchard/SoilData/Details.vue'));
        const LeavesDataDetails = defineAsyncComponent(() => import('@/Pages/Orchard/LeavesData/Details.vue'));
        const SymptomRecordDetails = defineAsyncComponent(() => import('@/Pages/Orchard/SymptomRecords/Details.vue'));
        const NutritionBalanceDetails = defineAsyncComponent(() => import('@/Pages/Orchard/NutritionBalances/Details.vue'));
        const panelTitle = (panelName, extra = '') => {
            let transKey = `panels.${panelName}.title`;
            return trans(transKey) + extra;
        };
        emitter.off('open-details-panel');
        emitter.on('open-details-panel', (data) => {
            title.value = data.title;
            component = data.component;
            componentData.value = data.componentData;
        });
        emitter.off('open-fertilization-details');
        emitter.on('open-fertilization-details', (data) => {
            component = FertilizationDetails;
            componentData.value = data;
            const date = DateTime.fromISO(data.date).toLocaleString(DateTime.DATE_MED);
            title.value = panelTitle('FertilizationDetails', ': ' + date);
            emitter.on('fertilization-saved', (data) => {
                Object.assign(componentData.value, data);
                const date = DateTime.fromISO(data.date).toLocaleString(DateTime.DATE_MED);
                title.value = panelTitle('FertilizationDetails', ': ' + date);
            });
            sidebarVisible.value = true;
        });
        emitter.off('open-irrigation-details');
        emitter.on('open-irrigation-details', (data) => {
            component = IrrigationDetails;
            componentData.value = data;
            const date = DateTime.fromISO(data.date).toLocaleString(DateTime.DATE_MED);
            title.value = panelTitle('IrrigationDetails', ': ' + date);
            emitter.on('irrigation-saved', (data) => {
                Object.assign(componentData.value, data);
                const date = DateTime.fromISO(data.date).toLocaleString(DateTime.DATE_MED);
                title.value = panelTitle('IrrigationDetails', ': ' + date);
            });
            sidebarVisible.value = true;
        });
        emitter.off('open-irrigation-water-data-details');
        emitter.on('open-irrigation-water-data-details', (data) => {
            component = IrrigationWaterDataDetails;
            componentData.value = data;
            title.value = panelTitle('IrrigationWaterDataDetails', ': ' + data.code);
            sidebarVisible.value = true;
        });
        emitter.off('open-leaves-data-details');
        emitter.on('open-leaves-data-details', async (data) => {
            component = LeavesDataDetails;
            componentData.value = await leavesDataService.getById(data.id);
            title.value = panelTitle('LeavesDataDetails', ': ' + data.code);
            sidebarVisible.value = true;
        });
        let event = 'open-nutrition-balance-details';
        emitter.off(event);
        emitter.on(event, (data) => {
            spinner.show();
            component = NutritionBalanceDetails;
            componentData.value = data;
            const date = DateTime.fromISO(data.created_at).toLocaleString(DateTime.DATE_MED);
            title.value = panelTitle('NutritionBalanceDetails', ': ' + date);
            sidebarVisible.value = true;
            spinner.hide();
        });
        const __returned__ = { title, get component() { return component; }, set component(v) { component = v; }, componentData, sidebarVisible, emitter, leavesDataService, spinner, FertilizationDetails, IrrigationDetails, IrrigationWaterDataDetails, SoilDataDetails, LeavesDataDetails, SymptomRecordDetails, NutritionBalanceDetails, panelTitle, get event() { return event; }, set event(v) { event = v; }, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
